import { ModalContent, ModalFooter } from '@components/modal';

type UnclaimHelpRequestModalProps = {
  onUnclaim: (helpInquiryId: number) => void;
  helpInquiryId: number;
};

const UnclaimHelpRequestModal = ({ onUnclaim, helpInquiryId }: UnclaimHelpRequestModalProps) => (
  <ModalContent title='Confirm Unclaim Help Inquiry'>
    <section className='modal-body'>
      <div>
        <p>Are you sure you would like to unclaim this help inquiry and return it to the Open status?</p>
      </div>
    </section>
    <ModalFooter onSave={() => onUnclaim(helpInquiryId)} saveText='Yes' cancelText='No' showCancelButton />
  </ModalContent>
);

export default UnclaimHelpRequestModal;
